export default "__VITE_ASSET__5kAOG3mE__"